import React, { useState } from 'react';

import PropTypes from 'prop-types';
import { Button, Spinner, Typography } from '@telus-uds/components-web';


import { EditOverlay } from '../../css';
import request from '../../../../../../../../utils/request';

const Overlay = ({ id, name, fetchData, setInDeleteMode }) => {
  const [isDeleting, setIsDeleting] = useState(false);

  const resetState = () => {
    setIsDeleting(false);
    setInDeleteMode(false);
    fetchData();
  };

  const handleDelete = async () => {
    setIsDeleting(true);

    try {
      const result = await request.delete(`/dealerships/${id}`);

      if (result && result.status === 200) {
        fetchData();
      }
    } catch (err) {
      resetState();
      throw err;
    }
  };

  return (
    <EditOverlay>
      <Spinner label="deleting..." show={isDeleting}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '1rem',
            width: '100%'
          }}
        >
          <div style={{ fontWeight: '600', textAlign: 'center' }}>
            <Typography block>
            {' '}
            Are you sure you want to delete {name}?
            </Typography>
          </div>
          <Button type="button" onClick={handleDelete} variant={{ danger: true }}>
            Confirm
          </Button>
          <Button
            variant={{ priority: 'low' }}
            type="button"
            onClick={() => setInDeleteMode(false)}
          >
            Cancel
          </Button>
        </div>
      </Spinner>
    </EditOverlay>
  );
};

Overlay.propTypes = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  fetchData: PropTypes.func.isRequired,
  setInDeleteMode: PropTypes.func.isRequired
};

export default Overlay;
